export default __webpack_public_path__ + "static/Silica_Pearls-717a3a673edb6f9c8375e83c60e48424.png";